module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "bulk-product-add"
  }, [_c('el-col', {
    staticClass: "text-right",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    staticClass: "small btn-add-bulk",
    staticStyle: {
      "margin-top": "15px",
      "padding": "10px 20px"
    },
    attrs: {
      "disabled": _vm.disableSubmit(),
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('button.add')))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.bulkAddProducts.selectedProducts.title')))]), _vm._v(" "), _c('el-table', {
    staticClass: "selected-products",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "10px"
    },
    attrs: {
      "data": _vm.selected,
      "empty-text": _vm.$t('static.bulkAddProducts.selectedProducts.noneSelected')
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "danger",
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-delete",
            "tabindex": "-1",
            "circle": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.handleRemove(scope.$index, _vm.selected)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.productName')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.name) + " "), (scope.row.info) ? _c('small', {
          staticClass: "details"
        }, [_vm._v(" (" + _vm._s(scope.row.info) + ")")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": 'Product Type',
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.productType) + " "), (scope.row.info) ? _c('small', {
          staticClass: "details"
        }, [_vm._v(" (" + _vm._s(scope.row.productType) + ")")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), (_vm.batches.length) ? _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.batch'),
      "width": "150px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "flex"
        }, [(_vm.enableCustomBatch && _vm.account.allowProducerBatches) ? _c('el-button', {
          staticStyle: {
            "margin-right": "5px"
          },
          attrs: {
            "type": "primary",
            "icon": "el-icon-plus",
            "size": "small",
            "circle": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addBatch(scope.row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (scope.row.batches.length) ? _c('el-select', {
          attrs: {
            "placeholder": "Select"
          },
          model: {
            value: (scope.row.batchId),
            callback: function($$v) {
              _vm.$set(scope.row, "batchId", $$v)
            },
            expression: "scope.row.batchId"
          }
        }, _vm._l((scope.row.batches), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1) : _vm._e()], 1)]
      }
    }], null, false, 1576689018)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.available'),
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.currentQty))])]
      }
    }])
  }), _vm._v(" "), (_vm.isOrderPage) ? [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.unitTypeId'),
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productTypeGroup == 'Beverage') ? _c('el-select', {
          attrs: {
            "placeholder": "Select"
          },
          model: {
            value: (scope.row.unitTypeId),
            callback: function($$v) {
              _vm.$set(scope.row, "unitTypeId", $$v)
            },
            expression: "scope.row.unitTypeId"
          }
        }, _vm._l((_vm.unitTypes.all), function(item) {
          return _c('el-option', {
            key: item.id,
            attrs: {
              "label": item.name,
              "value": item.id
            }
          })
        }), 1) : _vm._e()]
      }
    }], null, false, 1166675701)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.unitQty'),
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productTypeGroup == 'Beverage') ? _c('el-input-number', {
          ref: ("input" + (scope.$index)),
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "min": -999999,
            "max": 999999
          },
          model: {
            value: (scope.row.unitQty),
            callback: function($$v) {
              _vm.$set(scope.row, "unitQty", $$v)
            },
            expression: "scope.row.unitQty"
          }
        }) : _vm._e()]
      }
    }], null, false, 101108438)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.qty'),
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.productTypeGroup != 'Beverage') ? _c('el-input-number', {
          ref: ("input" + (scope.$index)),
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "min": -999999,
            "max": 999999
          },
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        }) : _vm._e()]
      }
    }], null, false, 2563757676)
  })] : [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('static.bulkAddProducts.selectedProducts.qty'),
      "width": "170"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          ref: ("input" + (scope.$index)),
          staticStyle: {
            "width": "150px"
          },
          attrs: {
            "min": -999999,
            "max": 999999
          },
          model: {
            value: (scope.row.qty),
            callback: function($$v) {
              _vm.$set(scope.row, "qty", $$v)
            },
            expression: "scope.row.qty"
          }
        })]
      }
    }])
  })]], 2), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "100%",
      "margin-top": "20px"
    },
    attrs: {
      "placeholder": _vm.$t('static.bulkAddProducts.findProducts.search'),
      "clearable": true
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('el-table', {
    staticClass: "product-search-table",
    staticStyle: {
      "width": "100%",
      "overflow": "auto",
      "height": "300px"
    },
    attrs: {
      "data": _vm.products.filter(function (data) { return !_vm.search || data.name.toLowerCase().includes(_vm.search.toLowerCase()); }),
      "show-header": false,
      "row-class-name": _vm.searchTableRowClassName
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.name) + " "), (scope.row.info) ? _c('small', {
          staticClass: "details"
        }, [_vm._v(" (" + _vm._s(scope.row.info) + ") - ID: " + _vm._s(scope.row.id))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.productType) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.$t('static.bulkAddProducts.selectedProducts.available')) + " " + _vm._s(scope.row.currentQty) + "\n          ")]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528b0932","hasScoped":false}!./src/app/components/bulkAddProductModal/bulkAddProductModal.html
// module id = 3010
// module chunks = 1